import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, defer } from 'rxjs';
import { OrderProcesStore } from 'src/app/+shared/stores/order-process.store';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { OrderProcessService } from 'src/app/jurisdiction/order-process/order-process.service';
import { TechnicalDataComponent } from '../technical-data/technical-data.component';
import { OrderProcessComponent } from '../order-process/order-process.component';
import { CcdDrrPersonalDataFormComponent } from '../personal-data-form/ccd-drr-personal-data-form.component';
import { CcdDrrDocumentsFormComponent } from '../documents-form/ccd-drr-documents-form.component';
import { ErrorService } from 'src/app/services/error/error.service';
import { ReviewSectionHelpers } from 'src/app/+shared/components/review-section/review-section.helpers';
import { DrrCcdDataStore } from '../drr-ccd-data.store';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  providers: [OrderProcessService],
})
export class DetailsComponent extends DestroyableComponent implements OnInit {
  applicationId: number;

  constructor(
    public DrrCcdDataStore: DrrCcdDataStore,
    private orderProcessStore: OrderProcesStore,
    private route: ActivatedRoute,
    private orderProcessService: OrderProcessService,
    private errorService: ErrorService,
    private reviewSectionHelpers: ReviewSectionHelpers
  ) {
    super();
  }

  @ViewChild('technicalData') technicalDataComponent: TechnicalDataComponent;
  @ViewChild('orderProcess') orderProcessComponent: OrderProcessComponent;
  @ViewChild('personalData') personalDataComponent: CcdDrrPersonalDataFormComponent;
  @ViewChild('documents') documentsComponent: CcdDrrDocumentsFormComponent;

  ngOnInit(): void {
    this.applicationId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.reviewSectionHelpers.initStoreData(this.applicationId);
    this.getOrderProcess();
  }

  public getOrderProcess() {
    this.preventLeak(this.orderProcessService.getOrderProcessDataByApplicationId(this.applicationId.toString())).subscribe(
      (response: any) => {
        this.errorService.throwErrorIfFailure(response, true);
        this.orderProcessStore.setOrderProcessData(response.orderprocess[0]);
      },
      error => this.errorService.throwErrorIfFailure(error, true)
    );
  }

  public saveChanges(event: { executorAction: string }) {
    const saveTechnicalDataObservable = defer(() => this.technicalDataComponent.save({ preventGoToNextPage: true }));
    const savePersonalDataObservable = defer(() => this.personalDataComponent.saveFormData(false));
    const saveDocumentsObservable = defer(() => this.documentsComponent.submit({ redirectAfterSubmit: false }));

    const updateAllSections$ = combineLatest([saveTechnicalDataObservable, savePersonalDataObservable, saveDocumentsObservable]);

    this.orderProcessComponent.updateOrderProcess(event.executorAction, { onUpdating$: updateAllSections$ });
  }
}
